import React from 'react'
import styled from '@emotion/styled'
import Step from './progressStep'
import useProgressBar from '../../hooks/components/useProgressBar'
import BreadcrumbWebComponentWrapper from './BreadcrumbWebComponentWrapper'

export default props => {
  const { year, make, model, trim, vinResults, urlState, globalState, mileage } = props
  let progressBar = null
  const isBreadcrumbWebComponentEnabled = globalState.isBreadcrumbWebComponentEnabled
  const { getStepName, stepClick, showProgressBar, steps, currentStep, furthestStep, currentPage, furthestPage, pages } = useProgressBar({ ...props, isBreadcrumbWebComponentEnabled })
  ////// **** - Integrated Breadcrumb Code - **** //////
  let vehicleName = ''
  let vehicleTrim = ''
  if (globalState) {
    const vin = vinResults && vinResults.vin ? vinResults.vin : urlState.vin
    if (globalState.isBreadcrumbWebComponentEnabled) {
      if (year && make && model) {
        vehicleName = `${year.displayName} ${make.displayName} ${model.displayName}`
      }
      if (trim) {
        vehicleTrim = trim.displayName
      }
      progressBar = <BreadcrumbWebComponentWrapper vehicleName={vehicleName} trim={vehicleTrim} vin={vin} currentStep={currentPage} pages={pages} stepClick={stepClick} mileage={mileage} />
      ////// **** - Integrated Breadcrumb Code - **** //////
    } else {
      progressBar = steps.map(
        (step, index) =>
          step?.pageNumbers?.length > 0 && (
            <Step key={`step${index}`} id={`step${index}`} step={getStepName(step)} first={index === 0} last={index + 1 === steps.length} currentStep={currentStep} furthestStep={furthestStep} index={index} onClick={() => stepClick(step, index)} />
          )
      )
    }
  }

  ////// **** - This is NEEDED for Array Parameters, stencil is weird (https://stenciljs.com/docs/properties#array-props)  - **** //////
  if (document.querySelector('ico-breadcrumb')) {
    document.querySelector('ico-breadcrumb').pages = pages
  }
  ////// **** - Integrated Breadcrumb Code - **** //////
  return showProgressBar && <StyledDiv data-testid={`global-progressBar`}>{progressBar}</StyledDiv>
}

const StyledDiv = styled.div`
  display: flex;
  width: 100%;
  max-width: 1024px;
  z-index: 2;
`
